(() => {
  const HEADER_FIXED = 'contains-park-header-v2-fixed';
  const HEADER_NON_FIXED = 'contains-park-header-v2-non-fixed';
  const HEADER_COMPACT = 'contains-park-header-v2-compact-mode';
  const header = document.querySelector('.park-header-v2');
  if (!header) {
    return;
  }
  const body = document.querySelector('body');
  const toggleButtons = window.park.$('[aria-controls="park-navigation"]');
  const navigation = document.getElementById('park-navigation');
  const panel = navigation.querySelector('.park-navigation__panel');

  function trackPageview(elem) {
    if (window.park.eventHub) {
      window.park.eventHub.trigger(document, 'park.navigation:pageview', {
        elem,
      });
    }
  }

  function addAdditionalBodyStyles(style) {
    body.classList.remove(HEADER_FIXED);
    body.classList.remove(HEADER_NON_FIXED);
    body.classList.remove(HEADER_COMPACT);
    body.classList.add(style);
  }

  function toggleMenu() {
    if (!navigation) {
      window.setTimeout(toggleMenu, 100);
      return;
    }

    if (header.classList.contains('park-header-v2--is-fixed')) {
      panel.removeAttribute('style');
    } else if (!window.park.device.isMobile()) {
      panel.style.top = `${header.clientHeight - document.querySelector('html').scrollTop}px`;
    }

    window.park.eventHub.trigger(document, 'park.menu-manager:open', {
      elem: navigation,
    });

    if (navigation.getAttribute('aria-hidden') === 'true') {
      toggleButtons.forEach(button => button.setAttribute('aria-expanded', 'true'));
      if (panel) {
        panel.scrollTop = 0;
      }

      window.park.overlayManager.register(navigation, toggleMenu);

      window.setTimeout(() => {
        navigation.removeAttribute('aria-hidden');
      }, 100);
    } else {
      toggleButtons.forEach(button => button.setAttribute('aria-expanded', 'false'));
      navigation.setAttribute('aria-hidden', 'true');

      window.park.overlayManager.unregister(navigation);
    }

    trackPageview(navigation);
  }

  if ('ontouchstart' in window) {
    window.park.eventHub.register('touchstart', '.park-header-v2__offer [data-close]', (e) => {
      window.park.storage.set('park.offer.suppress', '10');
      document.documentElement.classList.remove('with-offers');
      e.preventDefault();
      e.stopImmediatePropagation();
    });

    window.park.eventHub.register('touchstart', '.park-header-v2__menu-toggle-link', (e) => {
      toggleMenu();
      e.stopImmediatePropagation();
    });

    window.park.eventHub.register('touchend', '.park-header-v2__menu-toggle-link', (e) => {
      e.preventDefault();
      e.stopImmediatePropagation();
    });
  } else {
    window.park.eventHub.register('click', '.park-header-v2__menu-toggle-link', (e) => {
      toggleMenu();

      e.preventDefault();
      e.stopImmediatePropagation();
    });

    window.park.eventHub.register('click', '.park-header-v2__offer [data-close]', (e) => {
      window.park.storage.set('park.offer.suppress', '10');
      document.documentElement.classList.remove('with-offers');

      e.preventDefault();
      e.stopImmediatePropagation();
    });
  }

  window.park.observer.initialize('.park-header-v2__sales-cta', (elem) => {
    window.park.eventHub.trigger(document, 'park.header-sales-cta:impression', {
      elem: elem.querySelector('.park-header-v2__sales-cta-link'),
    });
  });

  window.park.eventHub.register('click', '.park-header-v2__sales-cta-link', (e) => {
    window.park.eventHub.trigger(document, 'park.header-sales-cta:click', {
      elem: e.target,
    });
  });

  // TRACK OVERSCROLL
  function trackHeaderOverscroll() {
    if (!header) {
      return;
    }

    if (header.classList.contains('park-header-v2--is-compact')) {
      addAdditionalBodyStyles(HEADER_COMPACT);
      return;
    }

    window.park.intersections.observe(header, null, (visibility) => {
      if (window.park.device.isMobile()) {
        return;
      }

      if (!visibility) {
        header.classList.add('park-header-v2--is-fixed');
        addAdditionalBodyStyles(HEADER_FIXED);
      } else {
        header.classList.remove('park-header-v2--is-fixed');
        addAdditionalBodyStyles(HEADER_NON_FIXED);
      }
    });
  }

  document.addEventListener('DOMContentLoaded', (trackHeaderOverscroll));

  // SEARCH
  const searchInputSelectors = ['#park-header-v2__top-row-search', '#park-header-v2__bottom-row-search'];
  searchInputSelectors.forEach((inputSelector) => {
    window.park.eventHub.register('input change', inputSelector, (e) => {
      const elem = e.target;
      const wrapper = elem.closest('.park-header-v2__search-input-wrapper');

      window.setTimeout(() => {
        wrapper.classList[elem.parkValue || elem.value ? 'add' : 'remove']('park-header-v2__search-input-wrapper--is-filled');
      });
    });

    window.park.eventHub.register('keydown', inputSelector, (e) => {
      const input = e.target;

      if (e.key !== 'Escape' && e.key !== 'Esc') {
        return;
      }

      input.value = '';

      window.park.eventHub.trigger(input, 'change');

      if (!input.parkValue && !input.value) {
        document.querySelector(`[for="${input.getAttribute('id')}"]`).focus();
      }
    });

    window.park.eventHub.register('reset', '.park-header-v2__search-form', (e) => {
      const input = e.target.querySelector('.park-header-v2__search-input');

      window.park.eventHub.trigger(input, 'change');

      input.focus();
    });
  });
})();
